import { fontConstants } from '../constants';
import { fontService } from '../services';
import { showToast } from '../services/toast';

export const fontActions = {
    fetchAllFonts,
    uploadFont,
    updateFont,
    deleteFont
};

function fetchAllFonts() {
    return dispatch => {
        dispatch(request());

        fontService.fetchAllFonts()
            .then(
                response => {
                    dispatch(success(response.data));
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: fontConstants.FETCH_ALLFONTS_REQUEST } }
    function success(fonts) { return { type: fontConstants.FETCH_ALLFONTS_SUCCESS, fonts } }
    function failure(error) { return { type: fontConstants.FETCH_ALLFONTS_FAILURE, error } }
}

function uploadFont(formData) {
    return dispatch => {
        dispatch(request());

        return fontService.uploadFont(formData)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                    return response;
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: fontConstants.UPLOAD_FONT_REQUEST } }
    function success(fonts) { return { type: fontConstants.UPLOAD_FONT_SUCCESS, fonts } }
    function failure(error) { return { type: fontConstants.UPLOAD_FONT_FAILURE, error } }
}

function updateFont(data) {
    return dispatch => {
        dispatch(request());

        return fontService.updateFont(data)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                    return response;
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: fontConstants.UPDATE_FONT_REQUEST } }
    function success(fonts) { return { type: fontConstants.UPDATE_FONT_SUCCESS, fonts } }
    function failure(error) { return { type: fontConstants.UPDATE_FONT_FAILURE, error } }
}

function deleteFont(fontId) {

    return dispatch => {
        dispatch(request());
        fontService.deleteFont(fontId)
            .then(
                (res) => {
                    dispatch(success(fontId));
                    showToast(res.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: fontConstants.DELETE_FONT_REQUEST } }
    function success(id) { return { type: fontConstants.DELETE_FONT_SUCCESS, payload: id } }
    function failure(error) { return { type: fontConstants.DELETE_FONT_FAILURE, error } }

}